import React, { useEffect, useState } from "react";

import MyProfile from "./my-profile";
import SocialNetworkBox from "./SocialNetworkBox";
import ContactInfoBox from "./ContactInfoBox";
import { getProfile } from "../../services/auth";
import DocumentUploadBox from "./DocumentUploadBox";

const index = () => {
  const [profileDetail, setProfileDetail] = useState({});
  const [socialData, setSocialData] = useState({});
  const [contactData, setContactData] = useState({});
  const [servicesList, setServicesList] = useState({});
  const fetchApplicant = async () => {
    try {
      const data = await getProfile();
      setProfileDetail(data?.data?.profileDetail);
      setSocialData(data?.data?.socialNetwork);
      setContactData(data?.data?.contactDetails);
      setServicesList(data?.data);
      // const socialDetail = data?.data?.socialNetwork;
    } catch (error) {}
  };
  useEffect(() => {
    fetchApplicant();
  }, []);

  return (
    <>
      <div className="ls-widget">
        <div className="tabs-box">
          <div className="widget-title">
            <h4> Company Profile</h4>
          </div>

          <MyProfile profileData={profileDetail} servicesList={servicesList} />
        </div>
      </div>

      <div className="ls-widget">
        <div className="tabs-box">
          <div className="widget-title">
            <h4>Company Contact Information</h4>
          </div>

          <div className="widget-content">
            <ContactInfoBox
              contactData={contactData}
              servicesList={servicesList}
              setServicesList={setServicesList}
            />
          </div>
        </div>
      </div>

      <div className="ls-widget">
        <div className="tabs-box">
          <div className="widget-title">
            <h4>
              Company Upload Documents :{" "}
              <span
                style={{
                  color: "grey",
                  fontSize: "15px",
                }}
              >
                (Any ONE of the following company proof documents is mandatory:{" "}
                <span className="text-danger">MSME Certificate</span>,{" "}
                <span className="text-danger">GST</span>,{" "}
                <span className="text-danger">PAN</span>,{" "}
                <span className="text-danger">CIN</span>, or{" "}
                <span className="text-danger">Startup Certificate</span>.){" "}
                <span className="text-danger">*</span>
              </span>
            </h4>
          </div>
          <div className="widget-content">
            <DocumentUploadBox
              profileData={profileDetail}
              servicesList={servicesList}
            />
          </div>
        </div>
      </div>

      <div className="ls-widget">
        <div className="tabs-box">
          <div className="widget-title">
            <h4>Company Social Handles</h4>
          </div>
          <div className="widget-content">
            <SocialNetworkBox socialData={socialData} />
          </div>
        </div>
      </div>
    </>
  );
};

export default index;
